<template>
  <div class="container container--narrow mgt-100">
    <div class=" t-center">
        <img src="images/portfolio/no-portfolio-data.svg" alt="" class="no-degree-image mgx-auto">
    </div>
    <div class="mgt-24 t-center t-headline8 font-r">
        {{$t('3026')}}
    </div>
    <div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{$t('3027')}}</div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCTabBar, MDCTabBarFoundation } from "@material/tab-bar";

export default {
  name: "learn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      tabBar: null,
    };
  },
  components: {
    TopAppBar,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {},
  },
};
</script>

<style scoped>
.notice-no-data {
  width: 109px;
  height: 74px;
}
</style>